export const SOUTH_AFRICA = 'South Africa';
